import { formatEmpresa } from "../../utils/functionsFormat";
import TrackerWrapper from "./TrackerWrapper";
import ArrowTracker from "../../assets/img/svg/providers/ArrowTracker.svg";
import ArrowTrackerW from "../../assets/img/svg/providers/ArrowTrackerW.svg";
import ArrowTrackerMovil from "../../assets/img/svg/providers/ArrowTrackerMovil.svg";
import ArrowTrackerMovilW from "../../assets/img/svg/providers/ArrowTrackerMovilW.svg";
import { ReactComponent as PasoCompletoIcon } from "../../assets/img/svg/providers/TrackerPasoCompleto.svg";
import { ReactComponent as PasoIncompletoIcon } from "../../assets/img/svg/providers/TrackerPasoIncompleto.svg";

const StepBulletMobile = ({
  idx,
  isActive,
  isPassed,
  onClick,
  zIndex,
  ml = 0,
}) => {
  const bg = isActive ? ArrowTrackerMovil : ArrowTrackerMovilW;
  const color = isActive ? "white" : isPassed ? "#223D51" : "gray";
  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "48px",
        height: "27px",
        backgroundImage: `url(${bg})`,
        backgroundSize: "fill",
        backgroundRepeat: "no-repeat",
        color,
        fontWeight: "bold",
        wordWrap: "break-word",
        zIndex,
        cursor: "pointer",
        marginLeft: ml,
      }}
      onClick={onClick}
    >
      <span>{idx}</span>
    </div>
  );
};

const StepItemMobile = ({ label, active, passed, onClick }) => {
  const bg = active ? "#223D51" : passed ? "white" : "#ededed";
  const color = active ? "white" : passed ? "#223D51" : "gray";
  const border = passed ? "1px solid #223D51" : "none";
  const Icon = passed ? PasoCompletoIcon : PasoIncompletoIcon;

  return (
    <div
      className="tracker-movil-container-item"
      style={{ backgroundColor: bg, border }}
      onClick={onClick}
    >
      <Icon width={20} />
      <span style={{ color }}>{label}</span>
    </div>
  );
};

const StepBlockDesktop = ({
  label,
  isActive,
  isPassed,
  zIndex,
  ml = "0px",
  mr = "-90px",
  pt = "20px",
  onClick,
}) => {
  const bg = isActive ? ArrowTracker : ArrowTrackerW;
  const color = isActive ? "white" : isPassed ? "#223D51" : "gray";
  const Icon = isPassed ? PasoCompletoIcon : PasoIncompletoIcon;

  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "270px",
        height: "100px",
        backgroundImage: `url(${bg})`,
        backgroundSize: "fill",
        backgroundRepeat: "no-repeat",
        color,
        fontWeight: "bold",
        wordWrap: "break-word",
        marginRight: mr,
        zIndex,
        cursor: "pointer",
        paddingTop: pt,
      }}
      onClick={onClick}
    >
      <div style={{ marginLeft: ml, marginRight: "10px" }}>
        <Icon width={20} />
      </div>
      <span>{label}</span>
    </div>
  );
};

const TrackerStepperProviders = ({
  width,
  selectedProvider,
  etapaSeleccionada,
  handleEtapaFilter,
}) => {
  const isActive = (etapa) =>
    selectedProvider?.etapa === etapa || etapaSeleccionada === etapa;

  const isPassed = (etapa) =>
    (selectedProvider?.etapa || 0) > etapa || (etapaSeleccionada || 0) > etapa;

  const providerName = selectedProvider
    ? formatEmpresa(
        selectedProvider?.nombre ?? selectedProvider?.razonSocial ?? ""
      )
    : null;

  const stages = [
    { etapa: 2, label: "Envío de documentación" },
    { etapa: 3, label: "Validación de documentos" },
    { etapa: 4, label: "Validación de costos" },
    { etapa: 5, label: "Capacitación" },
    { etapa: 6, label: "Curso de Check y entrega de manuales" },
    { etapa: 7, label: "Contrato" },
    { etapa: 8, label: "Periodo de prueba" },
    { etapa: 9, label: "Subir documentación final" },
    { etapa: 10, label: "Entrega de chaleco y credencial física" },
  ];

  const desktopIconLeftMargins = [
    "-40px",
    "10px",
    "10px",
    "10px",
    "20px",
    "-20px",
    "40px",
    "20px",
    "20px",
  ];

  const mobileHeader = (
    <div className="tracker-movil-container-section-p">
      <h2>Tracker de {providerName ?? "proveedores"}</h2>
      <div className="tracker-movil-container-body">
        {stages.map((s, i) => (
          <StepBulletMobile
            key={s.etapa}
            idx={i + 1}
            isActive={isActive(s.etapa)}
            isPassed={isPassed(s.etapa)}
            zIndex={110 - i}
            ml={i === 0 ? 0 : "-10px"}
            onClick={() => handleEtapaFilter(s.etapa)}
          />
        ))}
      </div>
    </div>
  );

  const mobileList = (
    <>
      {stages.map((s) => {
        const active = isActive(s.etapa);
        const passed =
          isPassed(s.etapa) ||
          (selectedProvider?.etapa ?? 0) >= s.etapa ||
          (etapaSeleccionada ?? 0) >= s.etapa;

        return (
          <StepItemMobile
            key={s.etapa}
            label={s.label}
            active={active}
            passed={passed}
            onClick={() => handleEtapaFilter(s.etapa)}
          />
        );
      })}
    </>
  );

  const desktop = (
    <>
      <h2>Tracker de {providerName ?? "proveedores"}</h2>

      <TrackerWrapper>
        <div
          className="tracker-container"
          style={{
            display: "flex",
            fontSize: "14px",
            textAlign: "left",
            flexWrap: "wrap",
            margin: "-18px 0 20px -26px",
            backgroundColor: "rgba(255, 255, 255, 0)",
          }}
        >
          {stages.map((s, i) => {
            const active = isActive(s.etapa);
            const passed =
              isPassed(s.etapa) ||
              (selectedProvider?.etapa ?? 0) >= s.etapa ||
              (etapaSeleccionada ?? 0) >= s.etapa;

            const labelNode =
              s.etapa === 4 ? (
                <>
                  Validación de <br /> costos
                </>
              ) : s.etapa === 6 ? (
                <>
                  Curso de Check <br />y entrega de <br />
                  manuales
                </>
              ) : s.etapa === 9 ? (
                <>
                  Subir <br />
                  documentación <br />
                  final
                </>
              ) : s.etapa === 10 ? (
                <>
                  Entrega de <br />
                  chaleco y <br />
                  credencial física
                </>
              ) : s.etapa === 2 ? (
                <>
                  Envío de <br />
                  documentación
                </>
              ) : s.etapa === 3 ? (
                <>
                  Validación de <br />
                  documentos
                </>
              ) : (
                s.label
              );

            return (
              <StepBlockDesktop
                key={s.etapa}
                label={labelNode}
                isActive={active}
                isPassed={passed}
                zIndex={110 - i}
                ml={desktopIconLeftMargins[i] ?? "10px"}
                onClick={() => handleEtapaFilter(s.etapa)}
              />
            );
          })}
        </div>
      </TrackerWrapper>
    </>
  );

  return width <= 1350 ? (
    <div className="tracker-movil-container">
      {mobileHeader}
      {mobileList}
    </div>
  ) : (
    desktop
  );
};

export default TrackerStepperProviders;
